import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { sendAIChatMessage } from '../../../services/ai_api';
import './ChatWidget.css';

const QUICK_PROMPTS = [
  'How do I login?',
  'Where is salary register?',
  'How to generate forms?',
  'OTP not received',
];

function ChatWidget() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      text: 'Hi! I am your AccunityHR Compliance assistant. Ask me how to use any screen, fix login issues, or navigate the application.',
    },
  ]);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const sendMessage = async (text) => {
    const question = (text || input).trim();
    if (!question || loading) return;

    setInput('');
    setMessages((prev) => [...prev, { role: 'user', text: question }]);
    setLoading(true);

    try {
      const response = await sendAIChatMessage({
        question,
        currentRoute: location.pathname,
      });

      setMessages((prev) => [
        ...prev,
        {
          role: 'assistant',
          text: response.answer || response.error || 'No response received.',
          disclaimer: response.disclaimer,
          remaining: response.remaining_questions,
        },
      ]);
    } catch (error) {
      const errorText =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Assistant is temporarily unavailable. Please try again later.';
      setMessages((prev) => [...prev, { role: 'assistant', text: errorText, isError: true }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-assistant-root">
      {open && (
        <div className="ai-assistant-panel">
          <div className="ai-assistant-header">
            <div>
              <strong>AI Assistance</strong>
              <div className="ai-assistant-subtitle">Guide for AccunityHR Compliance</div>
            </div>
            <button type="button" className="ai-assistant-close" onClick={() => setOpen(false)}>
              ×
            </button>
          </div>

          <div className="ai-assistant-quick-prompts">
            {QUICK_PROMPTS.map((prompt) => (
              <button
                key={prompt}
                type="button"
                className="ai-assistant-chip"
                onClick={() => sendMessage(prompt)}
                disabled={loading}
              >
                {prompt}
              </button>
            ))}
          </div>

          <div className="ai-assistant-messages">
            {messages.map((message, index) => (
              <div
                key={`${message.role}-${index}`}
                className={`ai-assistant-message ${message.role} ${message.isError ? 'error' : ''}`}
              >
                <div className="ai-assistant-bubble">{message.text}</div>
                {message.disclaimer && (
                  <div className="ai-assistant-disclaimer">{message.disclaimer}</div>
                )}
                {typeof message.remaining === 'number' && (
                  <div className="ai-assistant-meta">Questions left today: {message.remaining}</div>
                )}
              </div>
            ))}
            {loading && <div className="ai-assistant-loading">Thinking...</div>}
            <div ref={messagesEndRef} />
          </div>

          <form
            className="ai-assistant-input-row"
            onSubmit={(event) => {
              event.preventDefault();
              sendMessage();
            }}
          >
            <input
              type="text"
              value={input}
              onChange={(event) => setInput(event.target.value)}
              placeholder="Ask how to use this application..."
              disabled={loading}
            />
            <button type="submit" disabled={loading || !input.trim()}>
              Send
            </button>
          </form>
        </div>
      )}

      {/* <button
        type="button"
        className="ai-assistant-fab"
        onClick={() => setOpen((value) => !value)}
        aria-label="Open AI assistance"
      >
        {open ? 'Close Help' : 'AI Help'}
      </button> */}
    </div>
  );
}

export default ChatWidget;
